var _defs, _rect, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _line, _text, _circle, _line2, _text2, _circle2, _text3, _circle3, _line3, _line4, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBvm1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.96 452.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d5ddeb;}.cls-2,.cls-7{fill:#812990;}.cls-3{fill:#fff;}.cls-4{fill:#6b7b84;}.cls-5{fill:#231f20;}.cls-6,.cls-8{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-7{font-size:8px;font-family:ProximaNova-Regular, Proxima Nova;}.cls-8{stroke-dasharray:2 2;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "289.67 402.12 68.57 402.12 179.12 217.87 400.22 217.87 289.67 402.12"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "289.67 33.62 179.12 217.87 68.57 33.62 289.67 33.62"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.15 33.62 68.57 33.62 179.12 217.87 68.57 402.12 50.15 402.12 50.15 33.62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.65,234.87v.71H68.52v-4.06h3v.71h-2.2v1h1.84v.7H69.33v.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76,231.23v4.35h-.8v-.19a1.88,1.88,0,0,1-.92.24,1.62,1.62,0,0,1,0-3.24,2,2,0,0,1,.92.24v-1.4Zm-.8,3.41v-1.26a1.22,1.22,0,0,0-.77-.27.9.9,0,0,0-.94.9.89.89,0,0,0,.94.9A1.22,1.22,0,0,0,75.21,234.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.35,232.45v3.13h-.8v-.21a1.45,1.45,0,0,1-.85.26c-.92,0-1.34-.43-1.34-1.44v-1.74h.8v1.74c0,.48.24.72.68.72a1,1,0,0,0,.71-.25v-2.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.51,235a1.52,1.52,0,0,1-1.22.63,1.62,1.62,0,1,1,0-3.24,1.53,1.53,0,0,1,1.23.63l-.52.47a.87.87,0,0,0-.71-.38.9.9,0,1,0,0,1.8.85.85,0,0,0,.71-.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.86,232.45v3.13h-.8v-.23a1.67,1.67,0,0,1-.92.28,1.62,1.62,0,0,1,0-3.24,1.82,1.82,0,0,1,.92.26v-.2Zm-.8.94a1.19,1.19,0,0,0-.77-.28.9.9,0,1,0,0,1.8,1.18,1.18,0,0,0,.77-.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.22,233.11v1.11c0,.56.09.72.5.72.13,0,.26,0,.37,0v.6a2,2,0,0,1-.73.12.9.9,0,0,1-1-1v-1.53H90v-.66h.44v-1.22h.81v1.22h.88v.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.22,231.64a.47.47,0,0,1,.47-.47.47.47,0,0,1,0,.94A.47.47,0,0,1,93.22,231.64Zm.07.81h.8v3.13h-.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.76,234a1.72,1.72,0,1,1-1.71-1.62A1.67,1.67,0,0,1,98.76,234ZM98,234a.93.93,0,1,0-.92.9A.91.91,0,0,0,98,234Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103,233.84v1.74h-.8v-1.74c0-.49-.24-.73-.68-.73a1,1,0,0,0-.69.25v2.22H100v-3.13h.81v.2a1.46,1.46,0,0,1,.83-.26C102.55,232.39,103,232.82,103,233.84Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.33,233.78a7.6,7.6,0,0,1-.62.93l.49.47-.48.45-.45-.45a1.71,1.71,0,0,1-1.08.45c-.94,0-1.54-.44-1.54-1.18a1.22,1.22,0,0,1,.86-1.09,1.08,1.08,0,0,1-.36-.79,1.15,1.15,0,0,1,2.3-.08,1.25,1.25,0,0,1-.87,1.11l.69.66a4.31,4.31,0,0,0,.48-.67Zm-1.48.95-.91-.88c-.33.13-.48.33-.48.57s.27.56.76.56A1,1,0,0,0,108.85,234.73Zm-1-2.13c0,.3.25.47.36.58.26-.08.6-.27.6-.59a.49.49,0,0,0-.49-.54A.52.52,0,0,0,107.82,232.6Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117,231.52h.9l-1.9,4.06h-.38l-1.9-4.06h.9l1.19,2.65Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.93,231.64a.46.46,0,1,1,.46.47A.47.47,0,0,1,118.93,231.64Zm.06.81h.8v3.13H119Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.33,234.73a2.44,2.44,0,0,0,1.07.26c.37,0,.51-.14.51-.3s-.18-.26-.66-.36c-.68-.15-1.17-.37-1.17-1s.47-1,1.2-1a3.1,3.1,0,0,1,1.22.26l-.26.59a2.87,2.87,0,0,0-1-.21c-.31,0-.46.11-.46.28s.19.25.69.36c.73.15,1.15.4,1.15,1s-.46,1-1.26,1a2.79,2.79,0,0,1-1.35-.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128,232.45v3.13h-.81v-.23a1.66,1.66,0,0,1-.91.28,1.62,1.62,0,0,1,0-3.24,1.76,1.76,0,0,1,.91.26v-.2Zm-.81.94a1.17,1.17,0,0,0-.77-.28.9.9,0,1,0,0,1.8,1.14,1.14,0,0,0,.77-.27Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135,234.39c0,.78-.63,1.24-1.57,1.24a3.19,3.19,0,0,1-1.7-.38l.3-.64a2.91,2.91,0,0,0,1.42.31c.45,0,.71-.16.71-.46s-.27-.4-.86-.54c-.84-.19-1.51-.43-1.51-1.23s.57-1.22,1.5-1.22a4.05,4.05,0,0,1,1.56.33l-.34.66a3.59,3.59,0,0,0-1.24-.27c-.42,0-.65.18-.65.43s.29.41.9.55C134.43,233.37,135,233.64,135,234.39Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.93,234.24a.87.87,0,0,0,.9.7,1,1,0,0,0,.81-.38l.51.42a1.73,1.73,0,0,1-1.41.65,1.62,1.62,0,0,1,0-3.24,1.51,1.51,0,0,1,1.52,1.68c0,.06,0,.12,0,.17Zm0-.51h1.55a.69.69,0,0,0-.75-.7A.81.81,0,0,0,136.94,233.73Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.29,232.89a1.24,1.24,0,0,1,1-.5.51.51,0,0,1,.2,0v.87a2.14,2.14,0,0,0-.39-.05.75.75,0,0,0-.8.82v1.51h-.8v-3.13h.8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.77,232.45l-1.5,3.13h-.38l-1.5-3.13h.84l.85,1.78.85-1.78Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.84,231.64a.46.46,0,1,1,.46.47A.47.47,0,0,1,147.84,231.64Zm.06.81h.8v3.13h-.8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.88,235a1.5,1.5,0,0,1-1.21.63,1.62,1.62,0,1,1,0-3.24,1.51,1.51,0,0,1,1.22.63l-.52.47a.84.84,0,0,0-.7-.38.9.9,0,1,0,0,1.8.82.82,0,0,0,.7-.39Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.65,234.24a.87.87,0,0,0,.9.7,1,1,0,0,0,.81-.38l.51.42a1.73,1.73,0,0,1-1.41.65,1.62,1.62,0,0,1,0-3.24,1.51,1.51,0,0,1,1.52,1.68v.17Zm0-.51h1.55a.69.69,0,0,0-.75-.7A.83.83,0,0,0,154.66,233.73Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.33,234.73a2.52,2.52,0,0,0,1.08.26c.37,0,.51-.14.51-.3s-.18-.26-.66-.36c-.68-.15-1.17-.37-1.17-1s.47-1,1.2-1a3.1,3.1,0,0,1,1.22.26l-.26.59a2.87,2.87,0,0,0-1-.21c-.31,0-.46.11-.46.28s.19.25.69.36c.73.15,1.15.4,1.15,1s-.46,1-1.26,1a2.85,2.85,0,0,1-1.36-.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M157.83,200.56h-.77v2.18h-.46v-2.18h-.77v-.45h2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M160.65,200.11v2.63h-.45v-1.87l-.87,1.35-.86-1.35v1.87H158v-2.63h.5l.82,1.27.83-1.27Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.47,206.93v.85A6.11,6.11,0,0,0,87,207a5.3,5.3,0,0,0-1.94-.32,5.76,5.76,0,0,0-2.26.43,5.46,5.46,0,0,0-1.8,1.2,5.38,5.38,0,0,0-1.18,1.78,5.69,5.69,0,0,0,0,4.34A5.38,5.38,0,0,0,81,216.19a5.46,5.46,0,0,0,1.8,1.2,5.76,5.76,0,0,0,2.26.43h.22a6,6,0,0,0,2.29-.43v-3h0a3.08,3.08,0,0,1-1,.67,3.39,3.39,0,0,1-1.23.22,4.55,4.55,0,0,1-.52,0h0a3.52,3.52,0,0,1-.71-.18,2.78,2.78,0,0,1-1-.67,2.93,2.93,0,0,1,0-4.3,3.18,3.18,0,0,1,1-.66,3.4,3.4,0,0,1,1.23-.23,3.2,3.2,0,0,1,2.28.89,2.88,2.88,0,0,1,.94,2.16v5.57h2.67V206.93Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.13,217.82,71.2,212.1v5.72H68.52V202.74H71.2v5.7l5.93-5.68h3.8l-7.83,7.51,7.83,7.55Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.1,206.66a4.94,4.94,0,0,1,2,.39,4.62,4.62,0,0,1,1.53,1.08,4.93,4.93,0,0,1,1,1.6,5.48,5.48,0,0,1,.34,2v6.14h-2.67v-6.14a2.26,2.26,0,0,0-.78-1.76,2.58,2.58,0,0,0-1.83-.72,2.61,2.61,0,0,0-1.86.72,2.35,2.35,0,0,0-.75,1.76v6.14H92.37V207h2.68v.81a5,5,0,0,1,1.36-.79A4.35,4.35,0,0,1,98.1,206.66Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.38,207a4.85,4.85,0,0,1,1.8-.31v2.54a3.22,3.22,0,0,0-2.28.89,3,3,0,0,0-.93,2.16v5.59h-2.68V206.93H133v.83A5.9,5.9,0,0,1,134.38,207Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.24,206.66a6,6,0,0,1,2.29.43,5.93,5.93,0,0,1,1.88,1.2,5.76,5.76,0,0,1,1.26,1.78,5.46,5.46,0,0,1,0,4.34,5.76,5.76,0,0,1-1.26,1.78,5.93,5.93,0,0,1-1.88,1.2,6.34,6.34,0,0,1-4.59,0,5.93,5.93,0,0,1-1.88-1.2,5.76,5.76,0,0,1-1.26-1.78,5.46,5.46,0,0,1,0-4.34,5.76,5.76,0,0,1,1.26-1.78,5.93,5.93,0,0,1,1.88-1.2A6,6,0,0,1,142.24,206.66Zm0,2.54a3.19,3.19,0,0,0-2.28.89,3,3,0,0,0,1,5,3.41,3.41,0,0,0,1.24.22,3.3,3.3,0,0,0,1.22-.22,3.08,3.08,0,0,0,1-.67,2.93,2.93,0,0,0,0-4.3A3.28,3.28,0,0,0,142.24,209.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.76,206.66a6.07,6.07,0,0,1,2.3.43,5.88,5.88,0,0,1,1.87,1.2,5.45,5.45,0,0,1,1.26,1.78,5.35,5.35,0,0,1,0,4.34,5.45,5.45,0,0,1-1.26,1.78,5.88,5.88,0,0,1-1.87,1.2,6.37,6.37,0,0,1-4.6,0,5.88,5.88,0,0,1-1.87-1.2,5.45,5.45,0,0,1-1.26-1.78,5.35,5.35,0,0,1,0-4.34,5.45,5.45,0,0,1,1.26-1.78,5.88,5.88,0,0,1,1.87-1.2A6.07,6.07,0,0,1,154.76,206.66Zm0,2.54a3.18,3.18,0,0,0-2.27.89,3,3,0,0,0,1,5,3.49,3.49,0,0,0,1.24.22,3.39,3.39,0,0,0,1.23-.22,3.29,3.29,0,0,0,1-.67,3,3,0,0,0,0-4.3A3.33,3.33,0,0,0,154.76,209.2Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.13,206.93v.85a6,6,0,0,0-1.49-.8,5.34,5.34,0,0,0-1.94-.32,5.85,5.85,0,0,0-2.27.43,5.58,5.58,0,0,0,0,10.3,5.85,5.85,0,0,0,2.27.43h.22a6,6,0,0,0,2.29-.43v-3h0a3.29,3.29,0,0,1-1,.67,3.39,3.39,0,0,1-1.23.22,4.38,4.38,0,0,1-.52,0h0a3.79,3.79,0,0,1-.72-.18,3,3,0,0,1-1-5,3.25,3.25,0,0,1,1-.66,3.49,3.49,0,0,1,1.24-.23,3.22,3.22,0,0,1,2.28.89,2.87,2.87,0,0,1,.93,2.16v5.57h2.68V206.93Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.16,206.93v.85a5.94,5.94,0,0,0-1.5-.8,4.23,4.23,0,0,0-1-.25,7.09,7.09,0,0,0-1.16-.09,5.51,5.51,0,0,0-2.21.43,5.11,5.11,0,0,0-1.74,1.2,5.4,5.4,0,0,0-1.13,1.78,5.83,5.83,0,0,0-.4,2.18h0a5.62,5.62,0,0,0,.42,2.16,5.44,5.44,0,0,0,3,3,5.8,5.8,0,0,0,2.26.43h.4a5.75,5.75,0,0,0,2.11-.42v-3h0a3.08,3.08,0,0,1-1,.67,3.3,3.3,0,0,1-1.22.22,4.38,4.38,0,0,1-.52,0h0a3.45,3.45,0,0,1-.72-.18,3.09,3.09,0,0,1-2-2.82,3,3,0,0,1,.21-1.13.2.2,0,0,0,0-.08,3,3,0,0,1,.68-.94,3.29,3.29,0,0,1,1-.66,3.41,3.41,0,0,1,1.24-.23,3.18,3.18,0,0,1,2.27.89,3,3,0,0,1,.68.94.59.59,0,0,0,0,.08,3,3,0,0,1,.22,1.14v4.24a2.85,2.85,0,0,1-.94,2.14,3.29,3.29,0,0,1-3.88.49l-1.94,1.82a6.12,6.12,0,0,0,1.65.84,6,6,0,0,0,1.9.3,6,6,0,0,0,2.29-.44,6.13,6.13,0,0,0,1.88-1.21,5.76,5.76,0,0,0,1.26-1.78,5.3,5.3,0,0,0,.46-2.16v-9.56Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.63,227v.71H68.52v-4.05h3v.71H69.32v1h1.84v.69H69.32V227Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.77,223.36v4.33H76v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.92,1.92,0,0,1,.91.24v-1.39ZM76,226.75V225.5a1.19,1.19,0,0,0-.76-.27.89.89,0,0,0-.93.9.87.87,0,0,0,.93.89A1.14,1.14,0,0,0,76,226.75Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.87,224.58v3.12h-.8v-.21a1.49,1.49,0,0,1-.85.25c-.91,0-1.33-.42-1.33-1.43v-1.73h.8v1.73c0,.48.23.72.68.72a1.08,1.08,0,0,0,.7-.25v-2.2Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.79,227.12a1.5,1.5,0,0,1-1.2.62,1.61,1.61,0,1,1,0-3.22,1.49,1.49,0,0,1,1.21.62l-.51.48a.86.86,0,0,0-.7-.38.9.9,0,1,0,0,1.79.85.85,0,0,0,.7-.39Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.92,224.58v3.12h-.8v-.23a1.66,1.66,0,0,1-.92.27,1.62,1.62,0,0,1,0-3.23,1.93,1.93,0,0,1,.92.26v-.19Zm-.8.93a1.18,1.18,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.18,1.18,0,0,0,.77-.27Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.05,225.24v1.1c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2,2,0,0,1-.72.11.9.9,0,0,1-1-1v-1.52H93.8v-.66h.44v-1.22h.81v1.22h.87v.66Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.83,223.82a.46.46,0,1,1,.92,0,.46.46,0,1,1-.92,0Zm.06.8h.8v3.12h-.8Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.13,226.13a1.71,1.71,0,1,1-1.7-1.61A1.65,1.65,0,0,1,104.13,226.13Zm-.79,0a.92.92,0,0,0-1.83,0,.92.92,0,0,0,1.83,0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.11,226v1.74h-.8V226c0-.48-.23-.72-.68-.72a1.06,1.06,0,0,0-.69.25v2.21h-.8v-3.12h.8v.2a1.46,1.46,0,0,1,.84-.25C108.69,224.57,109.11,225,109.11,226Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.38,224.4v1.45h1.94v.71h-1.94v1.18h-.8v-4.05h3.06v.71Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.8,226.13a1.71,1.71,0,1,1-1.71-1.61A1.66,1.66,0,0,1,122.8,226.13Zm-.79,0a.92.92,0,0,0-1.84,0,.92.92,0,0,0,1.84,0Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.76,224.58v3.12H127v-.21a1.49,1.49,0,0,1-.85.25c-.91,0-1.33-.42-1.33-1.43v-1.73h.8v1.73c0,.48.23.72.67.72a1.09,1.09,0,0,0,.71-.25v-2.2Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.89,226v1.74h-.8V226c0-.48-.24-.72-.68-.72a1.06,1.06,0,0,0-.69.25v2.21h-.8v-3.12h.8v.2a1.45,1.45,0,0,1,.83-.25C132.47,224.57,132.89,225,132.89,226Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.17,223.36v4.33h-.81v-.19a1.81,1.81,0,0,1-.91.24,1.62,1.62,0,0,1,0-3.23,1.92,1.92,0,0,1,.91.24v-1.39Zm-.81,3.39V225.5a1.19,1.19,0,0,0-.76-.27.89.89,0,0,0-.93.9.87.87,0,0,0,.93.89A1.14,1.14,0,0,0,137.36,226.75Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.45,224.58v3.12h-.79v-.23a1.66,1.66,0,0,1-.92.27,1.62,1.62,0,0,1,0-3.23,1.93,1.93,0,0,1,.92.26v-.19Zm-.79.93a1.2,1.2,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.18,1.18,0,0,0,.77-.27Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.59,225.24v1.1c0,.56.09.72.49.72a3.7,3.7,0,0,0,.37,0v.6a2.06,2.06,0,0,1-.72.11.9.9,0,0,1-.95-1v-1.52h-.44v-.66h.44v-1.22h.81v1.22h.87v.66Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.37,223.82a.47.47,0,0,1,.46-.47.46.46,0,0,1,.45.47.45.45,0,0,1-.45.46A.46.46,0,0,1,149.37,223.82Zm.06.8h.8v3.12h-.8Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.67,226.13a1.71,1.71,0,1,1-1.71-1.61A1.65,1.65,0,0,1,155.67,226.13Zm-.79,0a.9.9,0,0,0-.92-.89.9.9,0,1,0,.92.89Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.65,226v1.74h-.8V226c0-.48-.24-.72-.68-.72a1.06,1.06,0,0,0-.69.25v2.21h-.8v-3.12h.8v.2a1.46,1.46,0,0,1,.84-.25C160.23,224.57,160.65,225,160.65,226Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 11.73,
    y1: 219.29,
    x2: 68.49,
    y2: 219.29
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(4.55 222.07)"
  }, "1")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 5.92,
    cy: 219.29,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 363.59,
    y1: 440.79,
    x2: 363.59,
    y2: 336.55
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(361.35 449.17)"
  }, "3")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 363.59,
    cy: 446.46,
    r: 5.67
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(178.37 8.63)"
  }, "2")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 180.74,
    cy: 5.92,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 179.14,
    y1: 112.93,
    x2: 179.14,
    y2: 11.26
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 182.31,
    y1: 11.26,
    x2: 182.31,
    y2: 277.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 68.63,
    y: 199.45,
    width: 92.13,
    height: 36.85
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBvm1);
export default __webpack_public_path__ + "static/media/bvm1.49151e5b72411af11c1d6243b0084892.svg";
export { ForwardRef as ReactComponent };